/*
 * Ritual By Pupe — quiet entrance motion for custom storefront sections.
 * Uses IntersectionObserver so motion runs only when a section is reached.
 */
(() => {
  'use strict';

  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const supportsIndividualTranslate = window.CSS?.supports?.('translate', '0 0');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

  const revealGroups = [
    { selector: '.ritual-category-discovery__head', stagger: 0 },
    { selector: '.ritual-category-card', stagger: 75 },
    { selector: '.ritual-featured-products__eyebrow, .ritual-featured-products__title, .ritual-featured-products__divider', stagger: 60 },
    { selector: '.ritual-product-card', stagger: 70 },
    { selector: '.ritual-featured-products__button', stagger: 0 },
    { selector: '.ritual-benefits__item', stagger: 65 },
    { selector: '.ritual-philosophy__content', stagger: 0 },
    { selector: '.ritual-ingredients__heading-wrap', stagger: 0 },
    { selector: '.ritual-ingredients__item', stagger: 70 },
    { selector: '.ritual-brand-showcase__card', stagger: 65 },
    { selector: '.ritual-instagram__heading-wrap, .ritual-instagram__slider', stagger: 75 },
    { selector: '.ritual-footer__brand, .ritual-footer__column', stagger: 55 }
  ];

  const reveal = (element) => {
    if (element.classList.contains('is-revealed')) return;

    element.classList.add('is-revealed');

    if (typeof element.animate !== 'function') return;

    const delay = Number(element.dataset.ritualRevealDelay || 0);
    const keyframes = supportsIndividualTranslate
      ? [
          { opacity: 0, translate: '0 18px' },
          { opacity: 1, translate: '0 0' }
        ]
      : [
          { opacity: 0 },
          { opacity: 1 }
        ];

    const animation = element.animate(
      keyframes,
      {
        duration: 620,
        delay,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'both'
      }
    );

    animation.finished
      .then(() => animation.cancel())
      .catch(() => {});
  };

  const observeWithin = (root = document) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    revealGroups.forEach(({ selector, stagger }) => {
      const elements = root.querySelectorAll(selector);
      const sectionIndexes = new Map();

      elements.forEach((element) => {
        if (element.dataset.ritualRevealBound === 'true') return;

        const section = element.closest('.shopify-section') || root;
        const index = sectionIndexes.get(section) || 0;
        sectionIndexes.set(section, index + 1);

        element.dataset.ritualRevealBound = 'true';
        element.dataset.ritualRevealDelay = String(Math.min(index * stagger, 300));
        element.classList.add('ritual-scroll-reveal');
        observer.observe(element);
      });
    });
  };

  const start = () => observeWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => observeWithin(event.target));
})();
